/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import {StatusBar, Platform} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

import theme from '../../global/styles/theme';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

export function StatusBarContainer() {
  const appTheme = useSelector((state: RootState) => state.config.appTheme);

  return (
    <LinearGradient
      colors={[
        theme.colors(appTheme).backgroundColor,
        theme.colors(appTheme).backgroundColor,
      ]}
      start={{x: 1, y: 0}}
      end={{x: 0, y: 1}}
      style={{
        height: Platform.OS === 'ios' ? 50 : StatusBar.currentHeight,
      }}>
      <StatusBar
        backgroundColor={'transparent'}
        translucent={true}
        networkActivityIndicatorVisible={true}
      />
    </LinearGradient>
  );
}
